<template>
  <div id="crear-expediente">
    <v-form ref="crearExpediente" v-model="esformularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Crear Expediente
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-tbody">
          </v-skeleton-loader>
          <div v-else>
            <custom-text-field
              cols=6
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar documento..."
              single-line
              hide-details>
            </custom-text-field>
            <v-data-table
              :headers="headers"
              :items="getDocumentos"
              :search="search"
              :items-per-page="itemsPerPage"
              hide-default-footer
              >
              <template v-slot:[`item.agregar`]="{ item }">
                <v-row justify="end">
                    <v-checkbox
                    class="my-0 py-0"
                    v-model="documentosSeleccionados"
                    :value="item"
                    dense>
                    </v-checkbox>
                </v-row>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixCrearExpediente"
            :disabled="!esformularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Crear Expediente">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import mixExpedientes from './mixExpedientes';

// import eventBus from '@/helpers/eventBus';

export default {
  name: 'CrearExpediente',
  mixins: [mixExpedientes],
  props: {
    idReferencia: {
      type: String,
      required: true,
    },
    moduloExpedienteOrigen: {
      type: String,
      required: true,
    },
    catalogoExpediente: {
      type: Array,
      required: true,
    },
    comoSeContrato: {
      type: String,
      required: false,
    },
  },
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      esformularioValido: false,
      enviandoFormulario: false,
      itemsPerPage: -1,
      search: '',
      documentosSeleccionados: [],
      headers: [
        {
          text: 'Descripcion',
          align: 'start',
          sortable: false,
          value: 'descripcion',
        },
        {
          text: 'Agregar', align: 'end', width: '120', value: 'agregar',
        },
      ],
    };
  },
  methods: {
    setIdReferencia() {
      switch (this.moduloExpedienteOrigen) {
        case 'contrato':
          this.expediente.idContrato = this.idReferencia;
          break;
        case 'obra':
          this.expediente.idObra = this.idReferencia;
          break;
        case 'licitacion':
          this.expediente.idLicitacion = this.idReferencia;
          break;
        case 'adjudicacionDirecta':
          this.expediente.idAdjudicacionDirecta = this.idReferencia;
          break;
        default: break;
      }
    },
    setDocumentos() {
      const documentos = this.getDocumentos;
      this.documentosSeleccionados = documentos;
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.crearExpediente.reset();
    },
  },
  computed: {
    getDocumentos() {
      if (this.comoSeContrato === 'AD') {
        return this.getCatalogoExpediente
          .filter((expediente) => expediente.esAdjudicacionDirecta === true);
      }
      if (this.comoSeContrato === 'LP') {
        return this.getCatalogoExpediente
          .filter((expediente) => expediente.esLicitacionPublica === true);
      }
      if (this.comoSeContrato === 'LS') {
        return this.getCatalogoExpediente
          .filter((expediente) => expediente.esLicitacionSimplificada === true);
      }
      return this.getCatalogoExpediente;
    },
    getCatalogoExpediente() {
      if (!this.catalogoExpediente) return [];
      return this.catalogoExpediente;
    },
  },
  mounted() {
    this.setDocumentos();
  },

};
</script>

<style>

</style>
